import { AbstractControl } from "@angular/forms";
import { Injectable } from "@angular/core";
import { UdcServiceService } from "../../Services/udc-service.service";

@Injectable()
export class UdcValidators {
  constructor(private service: UdcServiceService) {}

  shouldBeUnique(ac: AbstractControl) {
    // ac will hold each of the form controls
    const key1 = ac.get("key1").value;
    const key2 = ac.get("key2").value;
    const parentValue = ac.get("parentValue").value;
    const id = ac.get("id").value;

    if (key1 != null && key2 != null && parentValue != null) {
      this.service.checkForDuplicate(key1, key2, parentValue, id).subscribe(
        (response) => {
          if (response.length > 0)
            ac.get("parentValue").setErrors({ isDuplicate: true });
          else ac.get("parentValue").setErrors(null);
        },
        (error) => {
          ac.get("parentValue").setErrors(null);
        }
      );
    }
  }
}
